import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { AgreementSearchProvider } from './context/agreement-search-context';
import { AgreementSearchComponent } from './agreement-search-component';

export function AgreementSearchFactory() {
    return (
        <BaseLayoutFactory>
            <AgreementSearchProvider>
                <AgreementSearchComponent />
            </AgreementSearchProvider>
        </BaseLayoutFactory>
    );
}
